function capitalizeFirstLetter(input) {
  return input[0].toUpperCase() + input.slice(1)
}

const StringUtils = {
  capitalizeFirstLetter
}

export default StringUtils
